import { Tooltip } from "antd";

import { RVIcon, RVButton } from "@regal-voice/ui";
export function ToolbarButton({
    icon,
    tooltip,
    disabled,
    onClick,
    color,
    dataTestId,
}: {
    icon: string;
    tooltip: string;
    disabled?: boolean;
    color?: string;
    onClick?: () => void;
    dataTestId?: string;
}): JSX.Element {
    return (
        <Tooltip title={tooltip}>
            <RVButton
                type="text"
                disabled={disabled}
                icon={<RVIcon icon={icon} color={color} />}
                onClick={onClick}
                data-testid={dataTestId}
            />
        </Tooltip>
    );
}
